import { TEAM_SCHEDULER } from "../actions/utilities";

const INITIAL_STATE = {
  getTeamSchedulerLoading: false,
  getTeamSchedulerSuccess: false,
  getTeamSchedulerFailure: false,
  getTeamSchedulerError: null,
  teamSchedulerListData: {},
};

export const teamSchedulerReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TEAM_SCHEDULER.GET_TEAM_SCHEDULER_REQUEST:
      debugger;
      return {
        ...state,
        getTeamSchedulerLoading: true,
        getTeamSchedulerSuccess: false,
        getTeamSchedulerFailure: false,
        getTeamSchedulerError: null,
        teamSchedulerListData: {},
      };
    case TEAM_SCHEDULER.GET_TEAM_SCHEDULER_SUCCESS:
      debugger;
      return {
        ...state,
        getTeamSchedulerLoading: false,
        getTeamSchedulerSuccess: true,
        getTeamSchedulerFailure: false,
        getTeamSchedulerError: null,
        teamSchedulerListData: action.payload,
      };
    case TEAM_SCHEDULER.GET_TEAM_SCHEDULER_FAILURE:
      debugger;
      return {
        ...state,
        getTeamSchedulerLoading: false,
        getTeamSchedulerSuccess: false,
        getTeamSchedulerFailure: true,
        teamSchedulerListData: action.payload,
      };

    default:
      return state;
  }
};
